/**
 * Phase 5 item 4 — one currency format across the admin cockpit. Amounts of $1 or more
 * show 2 decimals (normal dollars); sub-$1 amounts show up to 4 decimals so fractions of
 * a cent stay visible (build costs are often a few cents). Always prefixed with `$`.
 */
export function formatUsd(n: number): string {
  const v = Number.isFinite(n) ? n : 0;
  const dp = Math.abs(v) >= 1 ? 2 : 4;
  return `$${v.toFixed(dp)}`;
}
